module.exports = __webpack_public_path__ + "static/img/icon_s8.3e5ec40.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/cloud/images/icon_s8.png
// module id = spCz
// module chunks = 21